jQuery(document).ready(function($){
  $(document).on('click', '.atl-label svg', function(){
    Swal.fire({
      title: 'Authority to leave',
      html: '<p>By selecting the box "Tick this box if you agree that our driver can leave the delivery if you are out" during checkout you will be authorising us to arrange for your parcel to be delivered to and left at your nominated shipping address without requiring you to sign for delivery ("ATL delivery"). In doing so, please note that the only confirmation of delivery that will be available and accepted to prove receipt will be obtained from the delivery driver. If you do not receive any items delivered via ATL delivery, they will not be replaced or refunded unless otherwise required by law</p>',
      showCloseButton: true,
      showConfirmButton: false,
      inputAutoFocus: false,
      customClass: {
        container: 'atl_popup_container',
        popup: 'atl_popup',
        header: 'atl_popup_header',
        closeButton: 'atl_close_btn',
      },
    });
  });
});